<kendo-textbox #googlePlacesAutocomplete class="googlePlacesAutocomplete_{{name}}" [hasPermission]="['members.update']" [isFallback]="false"></kendo-textbox>